import React, { useMemo, useState, useEffect, useRef } from "react";
import {
  ConnectCapitalFinancingPromotion,
  ConnectComponentsProvider,
} from "@stripe/react-connect-js";
import { loadConnectAndInitialize } from "@stripe/connect-js";
import { http } from "../../../../../services/HttpService";
import { HTTP_ENDPOINTS } from "../../../../../consts/api";
import { useCurrentAccountQuery } from "../../../../../api/queries/useAccountQuery";
import styles from "./StripeCapitalTile.module.scss";
import PoweredByStripeIcon from "../../../../../assets/Icons/PoweredByStripeIcon";

const StripeCapitalTile = () => {
  const { data: account } = useCurrentAccountQuery();
  const isEnabled = account?.globalSettings?.featureFlag?.stripeCapital;
  const [isLoaded, setIsLoaded] = useState(false);
  const containerRef = useRef(null);

  const stripeConnectInstance = useMemo(() => {
    if (!isEnabled) return null;
    return loadConnectAndInitialize({
      publishableKey: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY,
      fetchClientSecret: async () => {
        const res = await http.post(
          HTTP_ENDPOINTS.stripe.capitalAccountSession(),
        );
        return res?.data?.data?.client_secret;
      },
      appearance: {
        variables: {
          colorBackground: "#ffffff",
        },
      },
    });
  }, [isEnabled]);

  useEffect(() => {
    if (!containerRef.current || !isEnabled) return;

    const checkIframeLoaded = () => {
      const iframe = containerRef.current?.querySelector("iframe");
      if (iframe) {
        setIsLoaded(true);
      } else {
        setTimeout(checkIframeLoaded, 100);
      }
    };

    const timer = setTimeout(checkIframeLoaded, 500);
    return () => clearTimeout(timer);
  }, [isEnabled]);

  if (!isEnabled) {
    return null;
  }

  return (
    <div
      ref={containerRef}
      className={styles.container}
      style={{ display: isLoaded ? "block" : "none" }}
    >
      <div className="membership-title p-0 m-b-20 flex items-center gap-16">
        AR Capital <PoweredByStripeIcon />
      </div>
      <ConnectComponentsProvider connectInstance={stripeConnectInstance}>
        <ConnectCapitalFinancingPromotion layout="banner" />
      </ConnectComponentsProvider>
    </div>
  );
};

export default StripeCapitalTile;
